import { render, staticRenderFns } from "./AddStudentsTable.vue?vue&type=template&id=f8aeb610&scoped=true&"
import script from "./AddStudentsTable.vue?vue&type=script&lang=ts&"
export * from "./AddStudentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aeb610",
  null
  
)

export default component.exports